var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-line info-message",attrs:{"id":_vm.displayedText === ' ' ? 'msgDivider' : ''}},[_c('span',[_vm._v(_vm._s(_vm.displayedText))]),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }